import { ElementType } from 'react';

import { Link, LinkProps, Paper, PaperProps, styled } from '@mui/material';

import { withTooltip } from '../Tooltip';

export const NavigationCardWrapper = styled(Paper)<PaperProps & { component?: ElementType }>(
  ({ theme: { shape } }) => ({
    borderRadius: shape.borderRadius * 2,
  })
);

export const NavigationCardHeader = styled('div')(({ theme: { spacing } }) => ({
  padding: spacing(3, 3, 1, 3),
}));

export const NavigationCardList = styled('div')(({ theme: { palette } }) => ({
  display: 'flex',
  flexDirection: 'column',

  padding: 0,

  '& > .MuiTypography-root': {
    borderTop: 'none',
  },

  '& > .MuiTypography-root ~ .MuiTypography-root, & > .MuiTypography-root ~ span': {
    borderTop: `1px solid ${palette.divider}`,
  },
}));

export const NavigationCardListItem = styled(withTooltip(Link))<LinkProps & { component?: ElementType }>(
  ({ theme: { spacing, palette, typography }, 'aria-disabled': disabled }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: spacing(1),
    alignItems: 'center',

    ...typography['natter-text-sm'],
    fontWeight: 500,

    color: 'inherit',

    padding: spacing(2, 3),

    '&:hover': {
      textDecoration: 'none',
    },

    '& .MuiSvgIcon-root': {
      flexShrink: 0,
      color: palette.grey[500],
    },

    ...(disabled && {
      pointerEvents: 'none',
      color: palette.grey[400],

      '& .MuiSvgIcon-root': {
        color: palette.grey[300],
      },
    }),
  })
);
